import { BrainCircuit, XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const NotFoundScreen = () => {

    const navigate = useNavigate()
    const resetFlow = () =>{
        navigate("/")
    }

    return (<>
        <style>{`
            @keyframes float {
                0% { transform: translateY(0px); }
                50% { transform: translateY(-15px); }
                100% { transform: translateY(0px); }
            }
            .animate-float {
                animation: float 4s ease-in-out infinite;
            }
        `}</style>
        <div className="text-center fade-in flex flex-col items-center justify-center py-10">
            <div className="relative animate-float">
                <BrainCircuit className="text-gray-200 h-40 w-40" strokeWidth={0.5} />
                <XCircle className="absolute -bottom-2 -right-2 text-red-500 bg-gray-50 h-16 w-16" strokeWidth={1.5} />
            </div>
            <h1 className="text-6xl font-extrabold text-indigo-600 mt-8">404</h1>
            <h2 className="text-2xl font-semibold text-gray-800 mt-4">Oops! Our AI Took a Wrong Turn.</h2>
            <p className="text-gray-500 mt-2 max-w-md">
                It seems our analyst got its wires crossed searching the digital universe. Don't worry, we've sent it for a quick reboot.
            </p>
            <button
                onClick={resetFlow}
                className="mt-8 bg-indigo-600 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:bg-indigo-700 transition-all"
            >
                Return to Dashboard
            </button>
        </div>
    </>)
};